module.exports = __webpack_public_path__ + "img/TaiPing.11009092.png";